import React, { useEffect, useState } from "react";
import AuthPage from "./AuthPage";
import AuthPageMobile from "./AuthPageMobile";

export default function ResponsiveAuthPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <AuthPageMobile /> : <AuthPage />;
}
